<template>

			<div class="mzixunWrap" style="min-height: 500px;">
				<div class="mzixunLeft white" style="padding-left:50px;">
          <div class="abstractIitem" v-if="xuekezhuanye.yiliuXueke!=null&&xuekezhuanye.yiliuXueke!=''">
          	<div class="itemTile">
          		<h3>世界双一流学科</h3>
          	</div>
          	<div class="shezhiList" style="margin-left:30px;font-size:16px;">
          		{{xuekezhuanye.yiliuXueke}}
          	</div>
          </div>

          <div class="abstractIitem" v-if="xuekezhuanye.zhogndianMajor!=null&&xuekezhuanye.zhogndianMajor!=''">
          	<div class="itemTile">
          		<h3>全国重点学科（专业）</h3>
          	</div>
          	<div class="shezhiList" style="margin-left:30px;font-size:16px;">
          		{{xuekezhuanye.zhogndianMajor}}
          	</div>
          </div>

          <div class="abstractIitem" v-if="xuekezhuanye.teseMajor!=null&&xuekezhuanye.teseMajor!=''">
          	<div class="itemTile">
          		<h3>国家特色专业</h3>
          	</div>
          	<div class="shezhiList" style="margin-left:30px;font-size:16px;">
          		{{xuekezhuanye.teseMajor}}
          	</div>
          </div>

          <div class="abstractIitem" v-if="xuekezhuanye.gaigeMajor!=null&&xuekezhuanye.gaigeMajor!=''">
          	<div class="itemTile">
          		<h3>国家改革试点专业</h3>
          	</div>
          	<div class="shezhiList" style="margin-left:30px;font-size:16px;">
          		{{xuekezhuanye.gaigeMajor}}
          	</div>
          </div>

          <div class="abstractIitem" v-if="xuekezhuanye.yiliuMajor!=null&&xuekezhuanye.yiliuMajor!=''">
          	<div class="itemTile">
          		<h3>国家一流本科专业</h3>
          	</div>
          	<div class="shezhiList" style="margin-left:30px;font-size:16px;">
          		{{xuekezhuanye.yiliuMajor}}
          	</div>
          </div>

          <div class="abstractIitem" v-if="xuekezhuanye.areagaigeMajor!=null&&xuekezhuanye.areagaigeMajor!=''">
          	<div class="itemTile">
          		<h3>省级改革试点专业</h3>
          	</div>
          	<div class="shezhiList" style="margin-left:30px;font-size:16px;">
          		{{xuekezhuanye.areagaigeMajor}}
          	</div>
          </div>

          <div class="abstractIitem" v-if="xuekezhuanye.areayiliuXueke!=null&&xuekezhuanye.areayiliuXueke!=''">
          	<div class="itemTile">
          		<h3>省一流学科（专业）</h3>
          	</div>
          	<div class="shezhiList" style="margin-left:30px;font-size:16px;">
          		{{xuekezhuanye.areayiliuXueke}}
          	</div>
          </div>


          <div class="abstractIitem" v-if="xuekezhuanye.areateseMajor!=null&&xuekezhuanye.areateseMajor!=''">
          	<div class="itemTile">
          		<h3>省级特色专业（学科）</h3>
          	</div>
          	<div class="shezhiList" style="margin-left:30px;font-size:16px;">
          		{{xuekezhuanye.areateseMajor}}
          	</div>
          </div>

          <div class="abstractIitem" v-if="xuekezhuanye.areazhongdianXueke!=null&&xuekezhuanye.areazhongdianXueke!=''">
          	<div class="itemTile">
          		<h3>省级重点学科（专业）</h3>
          	</div>
          	<div class="shezhiList" style="margin-left:30px;font-size:16px;">
          		{{xuekezhuanye.areazhongdianXueke}}
          	</div>
          </div>

          <div class="abstractIitem" v-if="xuekezhuanye.tuiijanMajor!=null&&xuekezhuanye.tuiijanMajor!=''">
          	<div class="itemTile">
          		<h3>推荐专业</h3>
          	</div>
          	<div class="shezhiList" style="margin-left:30px;font-size:16px;">
          		{{xuekezhuanye.tuiijanMajor}}
          	</div>
          </div>

          <div class="abstractIitem" v-if="xuekezhuanye.zhuyue!=null&&xuekezhuanye.zhuyue!=''">
          	<div class="itemTile">
          		<h3>卓越工程师</h3>
          	</div>
          	<div class="shezhiList" style="margin-left:30px;font-size:16px;">
          		{{xuekezhuanye.zhuyue}}
          	</div>
          </div>

					<div class="abstractIitem" v-if="collegeMajor.length!=0">
						<div class="itemTile">
							<h3>开设专业</h3>
						</div>
						<div class="shezhiList">
							<div class="shezhiItem">
								<div class="link flex flex-wrap">
                  <div class="link flex flex-wrap">
                  	<a  @click="open(item)" v-for="(item,i) in collegeMajor" :key="'index'+i">{{item.majorName}}</a>
                  </div>
								</div>
							</div>
						</div>
					</div>
				</div>
        <div class="mask" v-if="flag">
          <div class="maskA">
            <div class="maskAA">
              <p>{{obj.collegeId}}</p>
              <img @click="flag=false" src="../../../assets/img/cha.png" />
            </div>
            <div class="mask_nr" v-html="content">

            </div>
          </div>

        </div>
			</div>


</template>

<script>
	export default {
		name: "",
		data() {
			return {
        collegeMajor:[],
        flag:false,
        obj:{},
        content:'',
        xuekezhuanye:{}
			}
		},
    props:{
      id:{
        type:String,
        default:''
      }
    },
		created(){
      console.log(this.id)
      let _this = this;
      this.$req.queryAllByLimit("collegeMajorInfo", {
      	pageSize: 30,
      	pageNum: 1,
      	queryObj:{
      		collegeId:this.id
      	}
      }).then(function(response) {
      	_this.collegeMajor = response.data
      })
      _this.$http.get(_this.$resourcesUrl + "/college/" + this.id + "/xuekezhuanye.json").then(function(
        response) {
       _this.xuekezhuanye = response
      })
		},
		methods: {
      open(obj){

        this.obj =obj
        let _this = this;
        _this.$http.get(_this.$resourcesUrl + "/collegemajor/" + this.id + "/"+obj.majorId+".html").then(function(
        	response) {
        	_this.content = response
          if(_this.content!=''&&_this.content!=null){
            _this.flag = true
          }
        }).catch(function(){
          let routeUrl = _this.$router.resolve({
            path: "/zyxq_zhuanyejieshao",
            query: {
              id: obj.majorId
            }
          });
          window.open(routeUrl.href, '_blank')
        })
      }
		}


	}
</script>

<style scoped>
  /* 遮罩层 查看专业遮罩层 ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .maskA {
    width: 910px;
    height: 90vh;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 910px;
    height: 64px;
    background-image: url("../../../assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    box-sizing: border-box;
    margin-bottom: 10px;
  }

  .mask_nr {
    width: 100%;
    height: calc(100% - 64px);
    padding: 20px;
    padding-bottom: 0px;
    padding-top: 0px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: auto;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANAN {
    width: 100%;
    height: calc(100% - 64px);
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }


  .maskAA {
    width: 100%;
  }

  .mask_nr {
    width: 100%;
    height: calc(100% - 70px);
  }




	.wrap{ background: #FBFBFB;}
	/* 右边固定 */
	.zuotab{height: auto; display: flex;flex-direction: column;position: fixed;top: 50%;right: 0px;transform:translate(-50%,-50%);}
	.zuotab figure{cursor: pointer; margin: 8px 0; width: 64px;height: 62px;border: 1px solid #FF0000;border-radius: 5px;display: flex;flex-direction: column; align-items: center;justify-content: center;}
	.zuotab figure img{width: 20px;height: 20px;}
	.zuotab figure figcaption{font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;margin-top: 10px;}

</style>



// WEBPACK FOOTER //
// src/views/information/collegeinfo/yuanxiaozhuanye.vue